import React, {useEffect, useState} from "react"
import { useNavigate } from "react-router-dom"
import GoBack from "../subsidiary/GoBack/GoBack"
import styles from './Login.module.css'
import {useDispatch, useSelector} from 'react-redux'
import {checkUser, fetchToken, sendCall} from './loginSlice'
import timerSVG from '../../assets/img/timer.svg'
const Login = () => {
    const phoneNumber = useSelector(state => state.loginSlice.phoneNumber)
    const navigation = useNavigate()
    const dispatch = useDispatch()
    const token = localStorage.getItem('token')
    const confirmationNumber = useSelector(state => state.loginSlice?.numberForCall.confirmationNumber)
    const code = useSelector(state => state.loginSlice?.numberForCall.code)
    const [timer, setTimer] = useState(120)
    useEffect(() => {
        // Функция, которая будет вызывать dispatch(checkUser({token}))
        const checkUserWithInterval = () => {
            dispatch(fetchToken({ phoneNumber, confirmationNumber, code })).then((params) => {
                if (!params.error) {
                    window.showAlert({ title: 'Авторизация прошла успешно', type: 'success' })
                    navigation('/')
                    const token = params.payload.token
                    dispatch(checkUser({ token }))
                }
            })
        };

        const interval = setInterval(checkUserWithInterval, 3000);
        return () => {
            clearInterval(interval);
        };
    }, [dispatch, token, phoneNumber]);
    useEffect(() => {
        const countdownInterval = setInterval(() => {
            setTimer(prevTimer => prevTimer - 1);
        }, 1000);
        if (timer === 0) {
            navigation(-1); // -1 означает переход на предыдущую страницу
        }
        return () => {
            clearInterval(countdownInterval);
        };
    },[timer])
    // useEffect(dispatch(sendCall))
    return (
        <section className={'main ' + styles.loginPage}>
            <GoBack text='Назад' />
            <div className="content-wrapper">
                <form name="form1" className={styles.formWrapper}>
                    <h1 className={"page-title " + styles.title}>
                        Позвоните по номеру
                    </h1>
                    <p className={styles.input_title}>
                        Наберите номер ниже — вход выполнится автоматически
                    </p>
                    <a
                        className={styles.callNumber}
                        href={confirmationNumber ? `tel:+${confirmationNumber}` : undefined}
                    >
                        {confirmationNumber ? `+${confirmationNumber}` : '…'}
                    </a>
                    <p className={styles.inputHint}>
                        Звонок можно совершить с того же номера, который вы указали
                    </p>
                </form>
                <div className={styles.timer}><img src={timerSVG} alt=""/>{timer} сек.</div>
            </div>
        </section >
    )
}
export default Login
